/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TimePeriodServiceGetResponse,
  TimePeriodServiceGetUploadFilesResponse,
} from '../models/index';
import {
    TimePeriodServiceGetResponseFromJSON,
    TimePeriodServiceGetResponseToJSON,
    TimePeriodServiceGetUploadFilesResponseFromJSON,
    TimePeriodServiceGetUploadFilesResponseToJSON,
} from '../models/index';

export interface TimePeriodApiApiTimePeriodCreatePostRequest {
    timePeriodDate?: Date;
}

export interface TimePeriodApiApiTimePeriodGetGetRequest {
    timePeriodDate?: Date;
}

export interface TimePeriodApiApiTimePeriodGetUploadFilesGetRequest {
    timePeriodDate?: Date;
}

/**
 * 
 */
export class TimePeriodApi extends runtime.BaseAPI {

    /**
     */
    async apiTimePeriodCreatePostRaw(requestParameters: TimePeriodApiApiTimePeriodCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }


        let urlPath = `/api/TimePeriod/Create`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiTimePeriodCreatePost(requestParameters: TimePeriodApiApiTimePeriodCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.apiTimePeriodCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTimePeriodGetAllGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TimePeriodServiceGetResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/TimePeriod/GetAll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TimePeriodServiceGetResponseFromJSON));
    }

    /**
     */
    async apiTimePeriodGetAllGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TimePeriodServiceGetResponse>> {
        const response = await this.apiTimePeriodGetAllGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTimePeriodGetGetRaw(requestParameters: TimePeriodApiApiTimePeriodGetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TimePeriodServiceGetResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timePeriodDate'] != null) {
            queryParameters['TimePeriodDate'] = (requestParameters['timePeriodDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/TimePeriod/Get`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TimePeriodServiceGetResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTimePeriodGetGet(requestParameters: TimePeriodApiApiTimePeriodGetGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TimePeriodServiceGetResponse> {
        const response = await this.apiTimePeriodGetGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTimePeriodGetUploadFilesGetRaw(requestParameters: TimePeriodApiApiTimePeriodGetUploadFilesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TimePeriodServiceGetUploadFilesResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['timePeriodDate'] != null) {
            queryParameters['TimePeriodDate'] = (requestParameters['timePeriodDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/TimePeriod/GetUploadFiles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TimePeriodServiceGetUploadFilesResponseFromJSON));
    }

    /**
     */
    async apiTimePeriodGetUploadFilesGet(requestParameters: TimePeriodApiApiTimePeriodGetUploadFilesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TimePeriodServiceGetUploadFilesResponse>> {
        const response = await this.apiTimePeriodGetUploadFilesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
